import { Component, Input, OnInit } from '@angular/core';
import { SocialBanner } from 'src/app/interfaces/social-banner.interface';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss']
})
export class SocialComponent implements OnInit {
  @Input() social: SocialBanner;
  constructor() { }

  ngOnInit() {
  }

}
